import React, { Component } from 'react';
import { Container, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactCalendar from 'react-calendar'
import CalendarItem from './CalendarItem'
import '../css/Calendar.css'
import EventNotificationContainer from './EventNotificationContainer';
import apiRequests from './api-helpers/ApiRequests'
import AddEventNotificationForm from './AddEventNotificationForm';
import ShowEventNotificationForm from './ShowEventNotificationForm';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'
import { addNotifications } from './redux/notificationSlice'



class Calendar extends Component {


	constructor(props) {
		super(props);


		this.state =
		{
			today: new Date(),
			eventNotificationsDayContainer: [],
			modalAddEventNotificationFormIsVisible: false,
			modalShowEventNotificationFormIsVisible: false,
			currentStartDate: new Date(),
			currentSelectedCalendarDay: new Date(),
			currentSelectedSignature: ""
		}

		let c = this.props.userData;
		this.navigationLabel = this.navigationLabel.bind(this);
		this.getCustomItem = this.getCustomItem.bind(this);
		this.setStartDate = this.setStartDate.bind(this);
		this.setNextMonth = this.setNextMonth.bind(this);
		this.setPrevMonth = this.setPrevMonth.bind(this);
		this.onActiveStartDateChange = this.onActiveStartDateChange.bind(this);
		this.onClickCalendarDay = this.onClickCalendarDay.bind(this);
		this.onClickAddNewEventNotifivation = this.onClickAddNewEventNotifivation.bind(this);
		this.onClickShowNewEventNotifivation = this.onClickShowNewEventNotifivation.bind(this);
		this.onChangeAddEventNotificationFormVisibility = this.onChangeAddEventNotificationFormVisibility.bind(this);
		this.onChangeShowEventNotificationFormVisibility = this.onChangeShowEventNotificationFormVisibility.bind(this);
		this.addNewEventNotificationCallback = this.addNewEventNotificationCallback.bind(this);
		this.loadCalendarDays = this.loadCalendarDays.bind(this);
		this.loadCalendarDaysResultCallback = this.loadCalendarDaysResultCallback.bind(this);

		this.calendarRef = React.createRef()
		this.todayItemRef = React.createRef();
		this.prevButtonRef = React.createRef();
		this.nextButtonRef = React.createRef();

	}

	componentDidMount()	{
		this.loadCalendarDays(this.state.currentStartDate)
	}


	setStartDate() {
		this.calendarRef.current.setActiveStartDate(new Date());
	}

	setPrevMonth() {
		this.prevButtonRef.current.click();
	}

	setNextMonth() {
		this.nextButtonRef.current.click();
	}

	getCustomItem({ activeStartDate, date, view }) {
		let objRef = React.createRef();
		if (this.state.today.setHours(0, 0, 0, 0) == date.setHours(0, 0, 0, 0)) {
			this.todayItemRef = objRef;
		}
		return <CalendarItem refObj={objRef} notificationsData={this.props.notificationsData} activeStartDate={activeStartDate} date={date} view={view} />
	}

	tileDisabled({ activeStartDate, date, view }) {

		return activeStartDate.getMonth() !== date.getMonth()

	}

	navigationLabel({ date, label, locale, view }) {
		return (
			<Container className="flex-grow-1 bg-white border-top p-0 m-0 px-2 py-1">
				<Row className="p-0 m-0">
					<Col className="p-0 m-0 text-start">
						<div onClick={this.setPrevMonth} className="btn p-0 lh-1 "><i className=" bi bi-arrow-left-square-fill fs-4 text-secondary prev-month-calendar "></i></div>
						<div onClick={this.setNextMonth} className="btn p-0 lh-1 ps-1 "><i className="bi bi-arrow-right-square-fill fs-4 text-secondary next-month-calendar "></i></div>
					</Col>
					<Col className="p-0 m-0 align-self-center">
						<p className="m-0 p-0 h6 text-secondary "><strong>{label.charAt(0).toUpperCase() + label.slice(1)}</strong></p>
					</Col>
					<Col className="p-0 m-0 text-end align-self-center">
						<div onClick={this.setStartDate} className=" btn btn-secondary m-0  p-0 px-3 py-1 small-text lh-1">{this.props.t('home.calendar.todayButton')}</div>
					</Col>
				</Row>
			</Container>
		);
	}

	formatShortWeekday = (locale, date) => {
		let currentWeekDay = "";
		switch (date.getDay()) {
			case 1:
				currentWeekDay = this.props.t('home.calendar.Monday');
				break;
			case 2:
				currentWeekDay = this.props.t('home.calendar.Tuesday');
				break;
			case 3:
				currentWeekDay = this.props.t('home.calendar.Wednesday');
				break;
			case 4:
				currentWeekDay = this.props.t('home.calendar.Thursday');
				break;
			case 5:
				currentWeekDay = this.props.t('home.calendar.Friday');
				break;
			case 6:
				currentWeekDay = this.props.t('home.calendar.Saturday');
				break;
			case 0:
				currentWeekDay = this.props.t('home.calendar.Sunday');
				break;

			default:
				currentWeekDay = "";
		}
		return currentWeekDay;
	}

	onActiveStartDateChange({ action, activeStartDate, value, view }) {
		if (action == null) {
			this.todayItemRef.current.setActiveItemElement();
		}
		this.setState((actualState) => ({ currentStartDate: activeStartDate }));
	}

	loadCalendarDays(date) {

		let tmpDate = new Date(date);
		tmpDate.setHours(12, 0, 0, 0); //UTC problrm resolve

		let params =
		{
			UserGroupId: this.props.userData.CompanyWorkflowId + "X",
			DataInHttpResponse: true,
			SearchParams: [
				// { Name: "date", Value: tmpDate.toISOString() },
				{ Name: "page", Value: "1" },
				{ Name: "size", Value: "1000000" },
				{ Name: "company", Value: this.props.userData.CompanyWorkflowId + "" }
			]
		};

		apiRequests.getDataByUrlWithParam('webconapi/GetNotificationsReportItems', params, this.loadCalendarDaysResultCallback);
	}

	loadCalendarDaysResultCallback(notificationsData) {

		this.props.dispatch(addNotifications(notificationsData));

	}

	addNewEventNotificationCallback(data) {



	}

	onClickCalendarDay(value, event) {

		this.setState({ currentSelectedCalendarDay: value });

	}

	onClickAddNewEventNotifivation() {

		this.onChangeAddEventNotificationFormVisibility(true);
	}

	onClickShowNewEventNotifivation(event) {

		this.onChangeShowEventNotificationFormVisibility(true, event.currentTarget.id);
	}

	onChangeAddEventNotificationFormVisibility(value) {

		this.setState({ modalAddEventNotificationFormIsVisible: value });

	}

	onChangeShowEventNotificationFormVisibility(value, signature) {


		this.setState({ modalShowEventNotificationFormIsVisible: value, currentSelectedSignature: signature });

	}


	render() {



		let notifications = [];
		let selectedDate = this.state.currentSelectedCalendarDay;

		if (this.props.notificationsData.length > 0) {

			selectedDate.setHours(0, 0, 0, 0);
			const calendarDay = this.props.notificationsData.find(x => { return new Date(x.EventDate).getTime() == selectedDate.getTime() });

			if (calendarDay) {
				notifications = calendarDay.Notifications;
			}
		}

		const isActiveAddNotificationButton = selectedDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)

		return (
			<div className="d-flex flex-column flex-grow-1  border rounded-3 shadow-sm my-0 ms-0 p-0">
				<div className="bg-white rounded-without-bottom-3 py-1">
					<p className="h6 text-secondary m-0 p-0 text-center font-weight-600  lh-1 py-1">
						<i className="bi bi-calendar4 pe-2"></i>
						<span>{this.props.t('home.calendar.title')}</span>
					</p>
				</div>
				<div className="d-flex flex-column flex-grow-1">
					<ReactCalendar ref={this.calendarRef} className="calendarControl m-0 p-0 bg-white"
						tileClassName="m-0 p-0"
						locale="pl-PL"
						tileContent={this.getCustomItem}
						prevLabel={<i ref={this.prevButtonRef} className="bi bi-arrow-left-square-fill fs-4 text-secondary"></i>}
						nextLabel={<i ref={this.nextButtonRef} className="bi bi-arrow-right-square-fill fs-4 text-secondary"></i>}
						defaultView="month"
						minDetail="month"
						showNeighboringMonth={false}
						showFixedNumberOfWeeks
						formatShortWeekday={this.formatShortWeekday}
						tileDisabled={this.tileDisabled}
						defaultValue={new Date()}
						onActiveStartDateChange={this.onActiveStartDateChange}
						onClickDay={this.onClickCalendarDay}
						navigationLabel={this.navigationLabel}
						reload={this.state.reload}
					/>
					<AddEventNotificationForm 
						currentSelectedCalendarDay={this.state.currentSelectedCalendarDay} 
						show={this.state.modalAddEventNotificationFormIsVisible} 
						onChangeAddEventNotificationFormVisibilityHandler={this.onChangeAddEventNotificationFormVisibility} 
						addNewEventNotificationCallback={this.addNewEventNotificationCallback} 
						userData={this.props.userData} 
					/>
					<ShowEventNotificationForm currentSelectedCalendarDay={this.state.currentSelectedCalendarDay} show={this.state.modalShowEventNotificationFormIsVisible} onChangeShowEventNotificationFormVisibilityHandler={this.onChangeShowEventNotificationFormVisibility} userData={this.props.userData} notificationsList={notifications} signature={this.state.currentSelectedSignature} />
					<hr className="text-secondary m-0 p-0 mb-1" />
					<div className="d-flex flex-grow-1 ">
						<div className="d-flex flex-column flex-grow-1">
							<OverlayTrigger placement="top" delay={{ show: 700, hide: 300 }} overlay={<Tooltip className="ms-1">{this.props.t('home.calendar.tooltipAddNotification')}</Tooltip>}>
								<div className={"d-flex flex-column d-inline-flex flex-shrink-1 justify-content-center align-items-center btn border btn-gray-border m-1 mx-2 rounded-3 shadow-sm bg-white button-new-notification " + (isActiveAddNotificationButton ? "" : " disabled")} onClick={this.onClickAddNewEventNotifivation}>
									<i className="bi bi-calendar-plus fs-3 lh-1 text-primary pe-2"></i>
									<p className="p-0 m-0  lh-1 text-primary btn-add-notified-font pt-1">{this.props.t('home.calendar.addNotificationButton')}</p>
								</div>
							</OverlayTrigger>
							<div className="flex-grow-1 overflow-auto scroll-grow-path p-0 px-1 m-1">
								{
									notifications.map((notificationsData) => (
										<EventNotificationContainer key={notificationsData.Signature} eventNotificationData={notificationsData} onClick={this.onClickShowNewEventNotifivation} />
									))
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function withMyHook(Component) {


	return function WrappedComponent(props) {

		const notificationsData = useSelector((state) => state.notification.notificationsData);
		const userData = useSelector((state) => state.currentUser.userData);
		const dispatch = useDispatch();
		const { t } = useTranslation();
		return <Component {...props} userData={userData} notificationsData={notificationsData} dispatch={dispatch} t={t} />;
	}
}

export default withMyHook(Calendar)










